import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import ThermalInvoice from "./ThermalInvoice";
import Barcode from "react-barcode";
import products from "../../../../Data/products.json";
import inventory from "../../../../Data/inventory.json";
import { PrinterOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { get_invoice, get_invoice_navigation } from "../../../../Controllers/Sales/Invoices";
import toast from "react-hot-toast";
import InvoiceA5 from "./a5Invoice";
import { Button } from "antd";
import Header from "../../../../Componets/Header";
import A4Invoice from "./a4nvoice";
import Loadercomponent from "../../../../Componets/Loader";
import headers from "../../../../Data/Forms/Sales/Invoices/headers";
import ScrollWrapper from "../../../../Componets/ScrollWrapper";

const InvoiceView = (props) => {
  let { id } = useParams();

  let navigate = useNavigate();
  let [searchParams] = useSearchParams();

  const [navInfo, setNavInfo] = useState({
    prev: null,
    next: null,
  });

  const [returnPage, setReturnPage] = useState(1);

  const invoiceRef = useRef();
  const invoiceA4Ref = useRef();
  const invoiceA5Ref = useRef();

  const [header, setHeader] = useState(headers);

  const handlePrint = useReactToPrint({
    content: () => invoiceRef.current,
  });

  const handleA4Print = useReactToPrint({
    content: () => invoiceA4Ref.current,
  });

  const handleA5Print = useReactToPrint({
    content: () => invoiceA5Ref.current,
  });

  const items = [
    {
      name: "LAMICTAL LIQUI-TABS 5MG",
      quantity: 1,
      Strip: 0,
      tablets: 0,
      price: 1.95,
      tax: 0.345,
      total: 2.047,
    },
    {
      name: "HAVRIX VACCINE 1440",
      quantity: 3,
      Strip: 0,
      tablets: 0,
      price: 6.95,
      tax: 1.043,
      total: 21.893,
    },
    {
      name: "ENGERIX VACCINE PAD10MCG/VIAL",
      quantity: 1,
      strips: 0,
      tablets: 0,
      price: 3.95,
      tax: 0.198,
      total: 4.147,
    },
    {
      name: "ZESTRIL TABLETS 5MG",
      quantity: 0,
      strips: 3,
      tablets: 0,
      price: 0.825,
      tax: 0.124,
      total: 2.599,
    },
    {
      name: "CLARITINE TABLETS 10MG",
      quantity: 0,
      strips: 2,
      tablets: 5,
      price: 1.413,
      tax: 0.155,
      total: 3.246,
    },
    {
      name: "ALLOFERIN INJ 10MG/2ML",
      quantity: 1,
      strips: 0,
      tablets: 0,
      price: 7.65,
      tax: 0.383,
      total: 8.033,
    },
    {
      name: "ALLOFERIN INJ 10MG/2ML",
      quantity: 1,
      strips: 0,
      tablets: 0,
      price: 7.65,
      tax: 0.383,
      total: 8.033,
    },
    {
      name: "ALLOFERIN INJ 10MG/2ML",
      quantity: 1,
      strips: 0,
      tablets: 0,
      price: 7.65,
      tax: 0.383,
      total: 8.033,
    },
    {
      name: "ALLOFERIN INJ 10MG/2ML",
      quantity: 1,
      strips: 0,
      tablets: 0,
      price: 7.65,
      tax: 0.383,
      total: 8.033,
    },
    {
      name: "ALLOFERIN INJ 10MG/2ML",
      quantity: 1,
      strips: 0,
      tablets: 0,
      price: 7.65,
      tax: 0.383,
      total: 8.033,
    },
  ];

  const total = items.reduce((acc, item) => acc + item.total, 0);

  const [loader, setLoader] = useState(false);
  const [values, setValues] = useState();

  const handleData = (invoice) => {
    const modifiedDetails = invoice.details.map((item) => ({
      ...item,
      tax: item.tax?.rate ?? 0,
    }));

    const updatedInvoice = { ...invoice, details: modifiedDetails };

    console.log(updatedInvoice, "Modified Invoice ✅");
    setValues(updatedInvoice);
    setLoader(false);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const invoice = await get_invoice(data);
      if (invoice?.status) {
        handleData(invoice?.data);
        console.log(invoice?.data, "invoice?.datainvoice?.datainvoice?.data");
      } else {
        toast?.error(invoice?.message);
      }
    } else {
      setLoader(false);
    }
  };

  const fetchNavigation = async () => {
    if (!id) return;

    const nav = await get_invoice_navigation({ id });

    if (nav?.status) {
      setNavInfo(nav.data);
    } else {
      setNavInfo({
        prev: null,
        next: null,
      });
    }
  };

  useEffect(() => {
    fetchData();
    fetchNavigation();

    const pageParam = searchParams.get("returnPage");

    if (pageParam) {
      setReturnPage(parseInt(pageParam, 10));
    }
  }, [id, searchParams]);

  const handleBack = () => {
    const page = returnPage || 1;
    navigate(`/app/sales?page=${page}`);
  };

  const goToInvoice = (invoiceId) => {
    if (!invoiceId) return;

    navigate(
      `/app/sales/view/${invoiceId}?returnPage=${returnPage}`
    );
  };

  return (
    <Header headers={header} setHeaders={setHeader} >
      <Loadercomponent loader={loader}>

        <div className="pb-4">
          <div className="flex justify-end flex-wrap">

            {/* Back */}
            <div className="p-2" onClick={handleBack}>
              <Button size="large">
                Back
              </Button>
            </div>

            {/* Previous */}
            <div
              className="p-2"
              onClick={() => goToInvoice(navInfo?.prev?.id)}
            >
              <Button
                size="large"
                icon={<LeftOutlined />}
                disabled={!navInfo?.prev}
              >
                {navInfo?.prev
                  ? `#INV-${navInfo.prev.number}`
                  : "Prev"}
              </Button>
            </div>

            {/* Next */}
            <div
              className="p-2"
              onClick={() => goToInvoice(navInfo?.next?.id)}
            >
              <Button
                size="large"
                disabled={!navInfo?.next}
              >
                {navInfo?.next
                  ? `#INV-${navInfo.next.number}`
                  : "Next"}{" "}
                <RightOutlined />
              </Button>
            </div>

            {/* A4 */}
            <div className="p-2" onClick={handleA4Print}>
              <Button size="large">
                A4 Print <PrinterOutlined className="text-lg" />
              </Button>
            </div>

            {/* Thermal */}
            <div className="pt-2" onClick={handlePrint}>
              <Button size="large">
                Thermal Print <PrinterOutlined className="text-lg" />
              </Button>
            </div>

            {/* A5 */}
            <div className="p-2" onClick={handleA5Print}>
              <Button size="large">
                A5 Print <PrinterOutlined className="text-lg" />
              </Button>
            </div>

          </div>
        </div>

        <ScrollWrapper>
          <div>
            <A4Invoice
              ref={invoiceA4Ref}
              values={values}
              items={items}
              total={total}
            />
          </div>
        </ScrollWrapper>

        <div className="hidden-on-screen">
          <ThermalInvoice
            ref={invoiceRef}
            values={values}
            items={items}
            total={total}
          />
        </div>

        <div className="hidden-on-screen">
          <InvoiceA5
            ref={invoiceA5Ref}
            values={values}
            items={items}
            total={total}
          />
        </div>
      </Loadercomponent>
    </Header>
  );
};

export default InvoiceView;
